import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-builder',
    templateUrl: './builder.component.html',
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BuilderComponent {

    constructor() {}
}
